export default __webpack_public_path__ + "locales/vi/Ldap.json?hash=e2380739c3fbf7de05d5ec826d31956e";